import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { Reveal } from '../../motion';
import { fadeUp } from '../../motion/variants';
import { canvasAccentText } from '../../theme';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  /** Buttons or filters shown on the right, wrapping below on mobile. */
  actions?: React.ReactNode;
  /** Small label above the title, e.g. the shop name. */
  eyebrow?: string;
}

/**
 * Consistent page framing for admin and mechanic screens, which each rolled
 * their own heading markup before.
 */
export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions, eyebrow }) => (
  <Reveal variants={fadeUp} sx={{ mb: { xs: 3, md: 4 } }}>
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      justifyContent="space-between"
      alignItems={{ xs: 'stretch', sm: 'flex-end' }}
      spacing={2}
    >
      <Box sx={{ minWidth: 0 }}>
        {eyebrow && (
          <Typography variant="overline" sx={{ display: 'block', mb: 0.5, color: canvasAccentText }}>
            {eyebrow}
          </Typography>
        )}
        <Typography variant="h4" component="h1">
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body1" color="text.secondary" sx={{ mt: 0.75, maxWidth: '60ch' }}>
            {subtitle}
          </Typography>
        )}
      </Box>

      {actions && (
        <Stack direction="row" spacing={1.5} flexWrap="wrap" sx={{ flexShrink: 0 }}>
          {actions}
        </Stack>
      )}
    </Stack>
  </Reveal>
);

export default PageHeader;
